var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vgsi-solutions", attrs: { id: "vgsi-solutions" } },
    [
      _vm.solutions
        ? _c(
            "div",
            { staticClass: "vgsi-solutions__wrap" },
            [
              _c("Panel", {
                attrs: {
                  solutions: _vm.solutions,
                  hotline: _vm.hotline,
                  more: _vm.more,
                  "current-floor": _vm.currentFloor
                }
              }),
              _vm._v(" "),
              _vm.solutions
                ? _c(
                    "div",
                    { staticClass: "vgsi-solutions__slick" },
                    [
                      _c(
                        "slick",
                        {
                          ref: "slick",
                          attrs: { options: _vm.slickOptions },
                          on: {
                            reInit: _vm.handleReInit,
                            afterChange: _vm.handleAfterChange
                          }
                        },
                        _vm._l(_vm.solutions, function(item, index) {
                          return _c("Slide", {
                            key: index,
                            attrs: { "prop-slide": item }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }